import { render } from "./SupplierContracts.vue?vue&type=template&id=79a8b713"
import script from "./SupplierContracts.vue?vue&type=script&lang=js"
export * from "./SupplierContracts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__